<template>
  <div>
    <px-circular-loading v-if="loading"/>
    <div v-if="!loading && !links.length">
      Nenhum link para esse registro
    </div>
    <v-simple-table
      v-if="!loading && links.length"
      fixed-header
    >
      <template v-slot:default>
        <thead>
        <tr>
          <th>Link</th>
          <th>Identificador</th>
          <th class="text-center"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="link in links" :key="link.id">
          <td>
            {{ linkDescription(link) }} #{{ link.id }}
            <px-span-tooltip
              v-if="link.codigoInterno"
              bottom
              text-class="caption"
              :text="`(${link.codigoInterno})`"
              tooltip="Código no ERP"/>
          </td>
          <td>
            {{ linkIdentificador(link) }}
          </td>
          <td>
            <px-cotacao-resposta-dialog-view v-if="isCotacao(link)" :cotacao-id="link.id"/>
            <px-aprovacao-detalhes-dialog-view v-if="isAprovacao(link)"
                                               :aprovacao-id="link.id" />
            <px-requisicao-detalhes-dialog-view v-if="isRequisicao(link)"
                                                :requisicao-id="link.id" />
            <v-btn icon target="_blank" link :to=linkRedirect(link)>
              <v-icon>mdi-open-in-new</v-icon>
            </v-btn>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import CompraService from '@/modules/compra/compra-service';

const LINK_DESCRIPTION_MAP = {
  COTACAO: 'Cotação',
  APROVACAO: 'Aprovação',
  REQUISICAO: 'Solicitação',
};

const LINK_URL_MAP = {
  COTACAO: link => `/cotacao/${link.id}/respostas`,
  APROVACAO: link => `/aprovacao/${link.id}`,
  REQUISICAO: link => `/requisicao/${link.id}`,
};

export default {
  props: {
    compra: Object,
  },
  data() {
    return {
      loading: false,
      links: [],
    };
  },
  computed: {
    isCotacao() {
      return link => link.tipo === 'COTACAO';
    },
    isAprovacao() {
      return link => link.tipo === 'APROVACAO';
    },
    isRequisicao() {
      return link => link.tipo === 'REQUISICAO';
    },
    linkDescription() {
      return link => (LINK_DESCRIPTION_MAP[link.tipo] || '');
    },
    linkRedirect() {
      return link => (LINK_URL_MAP[link.tipo](link));
    },
    linkIdentificador() {
      return link => (link.identificador ? link.identificador : '-');
    },
  },
  methods: {
    getLinks() {
      this.loading = true;
      CompraService.getLinks(this.compra.id)
        .then(({ data }) => {
          this.links = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getLinks();
  },
  components: {
    pxCotacaoRespostaDialogView: () => import('@/modules/cotacao/resposta/CotacaoRespostaDialogView.vue'),
    pxAprovacaoDetalhesDialogView: () => import('@/modules/aprovacao/detalhes/AprovacaoDetalhesDialogView.vue'),
    pxRequisicaoDetalhesDialogView: () => import('@/modules/requisicao/detalhes/RequisicaoDetalhesDialogView.vue'),
  },
};
</script>
